var logoImage = {
  src: 'https://images.ctfassets.net/rt5zmd3ipxai/wwbBneDgrgLJJimQ8RoW9/49631639f5d9b2c8e5d9de4c38fba898/NVA_Logo_Parent_RGB_250.png',
  // src: 'http://placehold.it/144x78 ',
  placeholderSrc: './images/image-placeholder.png',
  alt: 'Dummy Image',
  dataAnalyticsValue: 'dummy-image'
};
export { logoImage };
var addressObject = {
  classNameAnchor: '',
  classNameHeading: '',
  classNamePara: 'address-block',
  ariaLabel: 'Name Of Business',
  headingText: 'Name Of Business',
  address: '48 Warwick St.',
  address2: 'Office 410',
  city: 'London',
  state: 'Gt Lon',
  zip: 'W1B 5AW',
  peekingSource: '',
  peekingAltText: '',
  peekingClassName: 'peeking-image',
  HeadingType: 'h2'
};
export { addressObject };
var contactUsObject = {
  phoneText: 'T:',
  phone: '3103333333',
  faxText: 'F:',
  fax: '3101233333',
  emailText: 'E:',
  email: '1233103333'
};
export { contactUsObject };
var hoursOfOperationObject = {
  classNameHeading: '',
  ariaLabel: 'Hours of Operation',
  headingText: 'Hours of Operation',
  mainHoursText: 'Main Hours Text',
  extraHoursText: 'Extended Hours',
  extendedHours: false,
  perDayHoursDetailArray: ['Open 24 hrs', '8:30am to 1:00pm', '8:30am to 6:00pm', 'Closed', '8:30am to 6:00pm', '8:30am to 4:00pm', '8:30am to 6:00pm'],
  nameOfDay: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  hoursTextLine: 'CLOSED JULY 4TH'
};
export { hoursOfOperationObject };
var mapImage = {
  src: 'https://images.ctfassets.net/rt5zmd3ipxai/2CC6w9aRncolCkVrSuFTyG/6f229d2859506fe0179b01201232c3bb/NVA_-_Tampa_Bay_K-9_Rehabilitation_Center_1394.1_-_Map.png',
  // src: 'http://placehold.it/198x191',
  placeholderSrc: './images/image-placeholder.png',
  alt: 'Dummy Image'
};
export { mapImage };
var primaryLinksObject = [{
  label: 'About Us',
  url: 'http://www.nva.com/about-us',
  behavior: 'Open in the same page',
  dataAnalyticsValue: 'about-us'
}, {
  label: 'Services',
  url: 'http://www.nva.com/services',
  behavior: 'Open in a new page',
  dataAnalyticsValue: 'services'
}, {
  label: 'Events',
  url: 'http://www.nva.com/testimonials',
  behavior: 'Open in a new page',
  dataAnalyticsValue: 'events'
}];
export { primaryLinksObject };
var utilityLinksObject = [{
  label: 'Refer a Friend',
  url: null,
  behavior: 'Open in a new page'
}, {
  label: 'Careers',
  url: 'http://www.nva.com/careers',
  behavior: 'Open in the same page',
  dataAnalyticsValue: 'careers'
}, {
  label: 'Contact Us',
  url: 'http://www.nva.com/contact-us',
  behavior: 'Open in a modal',
  dataAnalyticsValue: 'contact-us'
}, {
  label: 'Privacy Policy',
  url: null,
  behavior: 'Open in a new page',
  dataAnalyticsValue: 'privacy-policy'
}, {
  label: 'Terms & Conditions',
  url: 'http://www.nva.com/privacy-policy',
  behavior: 'Open in a new page',
  dataAnalyticsValue: 'terms-conditions'
}];
export { utilityLinksObject };
var socialIconsData = {
  facebookUrl: 'https://www.facebook.com/NationalVeterinaryAssociates',
  twitterUrl: 'https://twitter.com/nvaonline',
  linkedInUrl: 'https://www.linkedin.com/company/national-veterinary-associates',
  youTubeUrl: 'https://www.youtube.com/watch?v=6ME3Ie7tlAA'
};
export { socialIconsData };